import NotFound from '@/views/common/404.vue';
import UserConsoleLayout from '@/views/kpi/layout/userConsoleLayout.vue';
import RolePermError from '@/views/common/role-perm-error.vue';
import PermError from '@/views/common/perm-error.vue';
import Forbidden from '@/views/common/403.vue';

/**
 * 页面未找到错误路由
 * @type {Route}
 */
export const notFoundRoute = {
    path: '/404',
    page: NotFound,
    props: true,
    group: 'kpi-user',
    requireAuth: false,
};

/**
 * 角色权限错误路由
 * @type {Route}
 */
export const rolePermErrRoute = {
    title: '权限不足',
    path: '/role-perm-error',
    layout: [ UserConsoleLayout ],
    page: RolePermError,
    group: 'kpi-user',
    requireAuth: false,
};

/**
 * 权限错误路由
 * @type {Route}
 */
export const permErrRoute = {
    path: '/perm-error',
    page: PermError,
    layout: [ UserConsoleLayout ],
    title: '无权操作',
    group: 'kpi-user',
    requireAuth: false,
};

/**
 * 未登录路由错误路由
 * @type {Route}
 */
export const forbiddenRoute = {
    title: '未登录或登录超时',
    path: '/403',
    name: 'forbidden',
    page: Forbidden,
    layout: [ UserConsoleLayout ],
    group: 'kpi-user',
    requireAuth: false,
};

/**
 * 匹配任意路径路由
 * @type {Route}
 */
export const matchAllRoute = {
    path: '/:catchAll(.*)',
    name: 'all-match',
    page: NotFound,
    beforeEnter: (to, from, next) => {
        next({
            path: '/404',
            query: {
                from: from.fullPath,
                to: to.fullPath,
            },
        });
    },
};

export const permissionRoutes = [
    rolePermErrRoute,
    permErrRoute,
    forbiddenRoute,
];

/**
 * 未登录表态路由表
 * @type {[Route]}
 */
export const staticRoutes = [
    {
        title: '用户登录',
        path: '/login',
        page: () => import('@/views/kpi/login/login.vue'),
        group: 'kpi-user',
        requireAuth: false,
    },
    {
        title: '用户注册',
        path: '/register',
        page: () => import('@/views/kpi/register/register.vue'),
        group: 'kpi-user',
        requireAuth: false,
    },
    {
        title: '找加密码',
        name: 'reset-password',
        path: '/reset-password',
        page: () => import('@/views/kpi/reset-password/reset-password.vue'),
        group: 'kpi-user',
        requireAuth: false,
    },
];
